// Prepara el HTML que responde la IA para mostrarlo en el diálogo de análisis
// (al crear la cotización y en el detalle).

// Análisis guardados antes de la corrección del back pueden traer los escapes crudos (Í, \")
const quitarEscapes = (texto) => texto
    .replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
    .replace(/\\n/g, "\n")
    .replace(/\\t/g, " ")
    .replace(/\\(["\\/])/g, "$1");

// Totales del resumen: con 0 van en verde, si hay alguno toman el color de su severidad
const TOTALES = [
    { patron: /total de errores\D*(\d+)/i, severidad: "error" },
    { patron: /total de advertencias\D*(\d+)/i, severidad: "warning" },
    { patron: /total de informativos\D*(\d+)/i, severidad: "info" },
];

const severidadDeTexto = (texto) => {
    // Es un conteo, no un resultado: va neutro
    if (/total de estructuras/i.test(texto)) return "info";

    for (const { patron, severidad } of TOTALES) {
        const match = texto.match(patron);
        if (match) return Number(match[1]) > 0 ? severidad : "ok";
    }

    // Hallazgos: "Severidad: Error / Advertencia / Informativo"
    const severidad = texto.match(/severidad\s*:?\s*([a-záéíóúñ]+)/i)?.[1]?.toLowerCase();
    if (!severidad) return null;
    if (/^(error|cr[ií]tic|alt)/.test(severidad)) return "error";
    if (/^(advertencia|warning|medi)/.test(severidad)) return "warning";
    if (/^(informativ|info|baj)/.test(severidad)) return "info";
    return null;
};

/**
 * Quita escapes y agrega la clase `ia-sev--ok|warning|error|info` a cada elemento
 * de lista según lo que diga (total en 0, severidad del hallazgo). Si el texto de
 * "Severidad: X" no está en un <li>, se colorea ese elemento solo.
 */
export const prepararHtmlAnalisis = (html) => {
    if (!html) return "";
    const limpio = quitarEscapes(html);
    if (typeof DOMParser === "undefined") return limpio;

    const doc = new DOMParser().parseFromString(`<div>${limpio}</div>`, "text/html");
    const raiz = doc.body.firstElementChild;

    raiz.querySelectorAll("li").forEach((li) => {
        const severidad = severidadDeTexto(li.textContent);
        if (severidad) li.classList.add(`ia-sev--${severidad}`);
    });

    raiz.querySelectorAll("p, span, div, td").forEach((el) => {
        if (el.closest("li") || el.querySelector("p, div, li, td")) return;
        if (!/severidad/i.test(el.textContent)) return;
        const severidad = severidadDeTexto(el.textContent);
        if (severidad) el.classList.add("ia-sev-texto", `ia-sev--${severidad}`);
    });

    return raiz.innerHTML;
};
